export default function formatCurrency(value: number) {
  return value
    .toLocaleString('nl-NL', { currency: 'EUR', minimumFractionDigits: 2 })
    .replace(/,00$/, ',-')
}
